/**
 * replacements for html-react-parser
 * documentation here: https://github.com/remarkablemark/html-react-parser#readme
 * array of functions, each should take arg domNode, plus optional addToCollection fn
 * {name, attribs, type, parent, children, prev, next, startIndex, endIndex}, addToCollection
 * and return a React element to replace the domNode, or null/falsy to use default replacement
 * Stops replacing after a truthy return value; earlier rules take precedence.
 * addToCollection(key, value) -- 
 *       adds value to array in parsedCollection[key], and returns the appended array
 */

import toObject from './toObject';

const parserReplacements = [toObject];

export default parserReplacements;
